import React from 'react'
import { Link } from 'react-router-dom'

export default function PetfriendlyWhere() {
  return (
    <>
    <section className="petpage-where">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-lg-7 col-md-6">
                    <img src="/image/pet-where.webp" className="img-responsive" alt="Pets Friendly" loading="lazy"/>
                </div>

                <div className="col-lg-5 col-md-6">
                    <div className="petwhere-box wow animate__animated animate__slideInUp">
                        <h2 className='heading'>Where Paws are Cherished and Comfort Comes Naturally</h2>
                        <p>At De Coracao Resort, we believe your furry companions deserve the same thoughtful hospitality as you. Our pet-friendly stays are designed to create a warm, welcoming environment where both you and your pets can relax and feel at home.</p>

                        <p><span>Exceptional Care:</span> Your pet’s well-being is our priority. With attentive care, regular updates, and a safety-first approach, we ensure every furry guest is looked after with comfort and attention.</p>

                        <p><span>Playtime:</span> From peaceful walks to open spaces for play, your pet enjoys moments tailored to their energy and personality—keeping them happy, active, and at ease throughout your stay.</p>

                        <Link to="/terms" className="arrow-butn">Pet Policy <img src="/image/right-arrow.svg" alt="arrow" /></Link>
                    </div>
                </div>
            </div>
        </div>
    </section> 
    </>
  )
}
